import { GridApi } from 'ag-grid-community';
import { useFetchCashInBankAccounts } from 'hooks/useClientDataServices';
import { PrintChecksVendorData } from 'pages/VendorsTablePage/components/PrintChecks/types';
import { createCashInBankDropdownOptions } from 'pages/VendorsTablePage/components/PrintChecks/utils';
import { getNumberFromCurrency } from 'pages/VendorsTablePage/components/VendorsTable/helpers';
import { VendorsTableDataType } from 'pages/VendorsTablePage/components/VendorsTable/types';
import {
  InvoiceDataType,
  AuthorizationPaymentRecordType,
  InvoiceDetails,
  CIBDropdownResult,
  AuthorizationPaymentListItem
} from './types';

export const processData = (
  selectedInvoices: InvoiceDataType[]
): AuthorizationPaymentRecordType[] => {
  const formattedInvoicesData: AuthorizationPaymentRecordType[] = [];
  selectedInvoices.forEach(
    ({ vendorNo, vendorName, paymentMethod, invoices }: InvoiceDataType) => {
      invoices.forEach((invoiceItem: InvoiceDetails) => {
        formattedInvoicesData.push({
          vendorNo,
          vendorName,
          paymentMethod,
          invoiceId: invoiceItem.invoiceId,
          amount: invoiceItem.amount,
          invoiceDescription: invoiceItem.invoiceDescription,
          dueDate: invoiceItem.dueDate,
          discountAmount: invoiceItem.discountAmount,
          netAmount: invoiceItem.netAmount,
          onHold: invoiceItem.onHold,
          invoiceDate: invoiceItem.invoiceDate
        });
      });
    }
  );
  return formattedInvoicesData;
};
export const processLandingPageData = (
  selectedInvoices: VendorsTableDataType[]
): AuthorizationPaymentListItem[] =>
  selectedInvoices.map(item => ({
    vendorNo: item.vendorNo,
    vendorName: item.vendorName,
    invoiceId: item.invoiceId,
    amount: getNumberFromCurrency(item.amount),
    invoiceDescription: item.invoiceDescription,
    invoiceDate: item.invoiceDate,
    dueDate: item.dueDate,
    discountAmount: getNumberFromCurrency(item.discountAmount),
    netAmount: getNumberFromCurrency(item.netAmount),
    onHold: item.onHold
  }));

export const onDownloadClick = (
  fileName: string,
  gridParamsApi?: GridApi | null
): void => gridParamsApi?.exportDataAsCsv({ fileName });

export const useCIBAccountsOptions = (): CIBDropdownResult => {
  const queryResult = useFetchCashInBankAccounts();
  const cashInBankAccountsOptions = createCashInBankDropdownOptions(
    queryResult?.data
  );
  return {
    cashInBankAccountsOptions,
    ...queryResult
  };
};

export const calculateTotalNetAmountSum = (
  data: PrintChecksVendorData[]
): string => {
  const sum = data.reduce((accumulator, item) => {
    const amountString = item?.totalNetAmount?.replace(/[^0-9.-]+/g, '');
    return accumulator + parseFloat(amountString ?? 0);
  }, 0);

  const formattedSum = sum.toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });

  return formattedSum;
};
